import { ChangeEvent, useEffect, useMemo, useState } from 'react'

import { AlternativesQuestionModel } from '../../../domain/models'

import { Input, InputRadio, SelectInput } from '..'

import * as S from './styles'

type RadioAndSelectWithJustificationQuestionProps = {
  options: AlternativesQuestionModel[]
  label: string
  order: number
  labelJustification: string
  labelThird?: string
  valueToJustification: string
  optionChecked: AlternativesQuestionModel
  onChange: (
    e: ChangeEvent<HTMLInputElement>,
    opt: AlternativesQuestionModel
  ) => void
}

const RadioAndSelectWithJustificationQuestion = ({
  options,
  label,
  order,
  labelJustification,
  labelThird,
  valueToJustification,
  optionChecked,
  onChange
}: RadioAndSelectWithJustificationQuestionProps) => {
  const [valuesToRadio, setValuesToRadio] = useState<AlternativesQuestionModel>(
    {} as AlternativesQuestionModel
  )
  const [inputSave, setInputSave] = useState<any>()

  const optionsToSelect = useMemo(
    () =>
      options?.map((item) => {
        return {
          value: item?.cdAlternativa,
          label: item?.alternativa
        }
      }),
    [options]
  )

  useEffect(() => {
    if (optionChecked) {
      setValuesToRadio(optionChecked)
    }
  }, [optionChecked])

  return (
    <S.Wrapper>
      <S.Title>{label}</S.Title>

      {options.length <= 2 ? (
        <S.RadioYesOrNoOptions>
          {options.map((option) => (
            <InputRadio
              key={option.cdAlternativa}
              name={`radio-with-justification-${order}`}
              defaultChecked={
                optionChecked?.cdAlternativa === option.cdAlternativa
              }
              label={option.alternativa}
              labelFor={`${option.alternativa}-${order}`}
              onCheck={() => {
                setValuesToRadio({
                  cdAlternativa: option.cdAlternativa,
                  alternativa: option.alternativa
                })
                onChange(inputSave, {
                  cdAlternativa: option.cdAlternativa,
                  alternativa: option.alternativa
                })
              }}
              labelColor="#4f4f4f"
            />
          ))}
        </S.RadioYesOrNoOptions>
      ) : (
        <SelectInput
          name={`select-with-justification-${order}`}
          options={optionsToSelect}
          hasQuestionInput
          hasSelectOption={false}
          labelColor="#4f4f4f"
          onChange={(e) => {
            const checkedValue = optionsToSelect.find(
              (item) => item.value === Number(e.target.value) && item.label
            )

            setValuesToRadio({
              cdAlternativa: Number(e.target.value),
              alternativa: checkedValue?.label || ''
            })
            onChange(inputSave, {
              cdAlternativa: Number(e.target.value),
              alternativa: checkedValue?.label || ''
            })
          }}
          defaultValue={optionChecked?.cdAlternativa}
        />
      )}

      {(valuesToRadio?.alternativa?.replace(' ', '') === 'Sim' ||
        valuesToRadio?.alternativa?.replace(' ', '') === 'Casado' ||
        valuesToRadio?.alternativa?.replace(' ', '') === 'Viúvo' ||
        valuesToRadio?.alternativa?.replace(' ', '') ===
          'Separado/Divorciado' ||
        valuesToRadio?.alternativa === 'União estável ' ||
        valuesToRadio?.alternativa?.replace(' ', '') === 'Namorando' ||
        valuesToRadio?.alternativa?.replace(' ', '') === 'Outro' ||
        valuesToRadio?.alternativa?.replace(' ', '') === 'Outros') && (
        <Input
          name="label-justification"
          type="text"
          label={
            valuesToRadio?.alternativa?.replace(' ', '') === 'Outros'
              ? ''
              : labelJustification
          }
          labelColor="#000"
          hasQuestionInput
          placeholder="Resposta:"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setInputSave(e)
            onChange(e, valuesToRadio)
          }}
          defaultValue={valueToJustification}
        />
      )}
      {labelThird && valuesToRadio?.alternativa?.replace(' ', '') === 'Não' && (
        <Input
          name="label-third"
          type="text"
          label={labelThird}
          labelColor="#000"
          hasQuestionInput
          placeholder="Resposta:"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setInputSave(e)
            onChange(e, valuesToRadio)
          }}
          defaultValue={valueToJustification}
        />
      )}
    </S.Wrapper>
  )
}

export default RadioAndSelectWithJustificationQuestion
